module.exports = __webpack_public_path__ + "static/media/onetouch.b3cbe677.jpeg";